// extracted by mini-css-extract-plugin
export default {"container":"Title_container__9RC62","nameOfPage":"Title_nameOfPage__2LkxF","links":"Title_links__BXfMT","slash":"Title_slash__ZdjVa"};